import type { UserEventInput } from "@nifgash/shared/validators";
import { api } from "./client";

export type Eligibility =
  | { ok: true }
  | { ok: false; reason: "not_premium" | "no_attended" };

export async function getEligibility(): Promise<Eligibility> {
  return api<Eligibility>("/api/events/eligibility");
}

export async function submitEvent(input: UserEventInput): Promise<{ ok: true; event_id: string }> {
  return api<{ ok: true; event_id: string }>("/api/events", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

/** Final step of creation: notify admins for moderation (after optional image). */
export async function notifyReview(eventId: string): Promise<void> {
  await api(`/api/events/${eventId}/notify-review`, { method: "POST" });
}
